import lpApp from '../lp_app';

/*
 * Project: LegalPlace assistant
 * File: src/app/indexes/conditions_dependencies.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
*/

class LpConditionDependenciesIndex {
  constructor() {
    this.dependencies = {};
    this.var_dependencies = {};
  }

  buildDependencies() {
    const opts = lpApp.references.options;
    if (opts) {
      const allKeys = Object.keys(opts);
      allKeys.forEach((idx) => {
        const now = opts[idx];
        if (now.meta.conditional) {
          now.meta.conditions.forEach((jdx) => {
            if (idx.o !== false && jdx.o) {

              if (typeof this.dependencies[jdx.o] === 'undefined') {
                this.dependencies[jdx.o] = [now.meta.id];
              } else {
                this.dependencies[jdx.o].push(now.meta.id);
              }
            } else if (idx.o !== false && jdx.v) {
              if (typeof this.var_dependencies[jdx.v] === 'undefined') {
                this.var_dependencies[jdx.v] = [now.meta.id];
              } else {
                this.var_dependencies[jdx.v].push(now.meta.id);
              }
            }
          }, this);
        }
      }, this);
    }
  }

  getDependecies(id) {
    return this.dependencies[id];
  }

  getVariableDependecies(id) {
    return this.var_dependencies[id];
  }
}

export default LpConditionDependenciesIndex;



// WEBPACK FOOTER //
// ./src/app/indexes/conditions_dependencies.js